import { LARGE_BREAKPOINT, MEDIUM_BREAKPOINT } from '@/components/modular-grid/constants';
import { BannerType } from '@/components/modular-grid/types';
import { ImageType } from '@/types/gameTypes';

type BannerAsset = {
  type: BannerType;
} & ImageType;

/**
 * Prepare an array of sized sources to let our AssetLayer component to render
 * a responsive image.
 *
 * @param largeAsset - Desktop asset
 * @param smallAsset - Mobile and tablet asset
 */
export default function createSizedSources(
  largeAsset?: BannerAsset,
  smallAsset?: BannerAsset
) {
  if (!largeAsset && !smallAsset) return;

  const sizedSources = [];
  if (largeAsset) {
    sizedSources.push({
      min: LARGE_BREAKPOINT.min,
      src: largeAsset.source,
    });
  }

  if (smallAsset) {
    sizedSources.push({
      max: MEDIUM_BREAKPOINT.max,
      src: smallAsset.source,
    });
  }

  return sizedSources;
}
